import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RiraLogo from "./RiraLogo";

function PublicNav() {
  const navigate  = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`lp-nav${scrolled ? " lp-nav--scrolled" : ""}`}>
      <div className="lp-nav-brand" style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
        <RiraLogo size={30} />
      </div>
      <div className="lp-nav-links">
      </div>
      <div className="lp-nav-actions">
        <button className="lp-nav-signin" onClick={() => navigate("/auth")}>Sign in</button>
        <button className="lp-nav-cta"    onClick={() => navigate("/auth?tab=register")}>Get Started</button>
      </div>
    </nav>
  );
}

export default PublicNav;
